import moment from 'moment';
import * as _ from 'lodash';

export default {
  methods: {
    roundAndFormat(number, precision) {
      return this.valorReal(_.round(number, precision), precision);
    },
    round(number, precision) {
      return _.round(number, precision);
    },
    formatCep(cep = null) {
      if (cep === null) {
        return '';
      }

      return cep.replace(/(\d{5})(\d{3})/g, '$1-$2');
    },
    formatCpfCnpj(valor = null) {
      if (valor === null) {
        return '';
      }
      if (valor.length <= 11) {
        // eslint-disable-next-line
        return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, `\$1.\$2.\$3\-\$4`);
      }
      // eslint-disable-next-line
      return valor.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/g, '$1.$2.$3/$4-$5');
    },
    valorUS(valor = 0) {
      let valorFormatado = valor;
      if (typeof valor === 'string') {
        valorFormatado = valor.split('.').join('');
        return parseFloat(valorFormatado.replace(',', '.').replace('R$ ', ''));
      }
      return valor;
    },
    valorReal(valor = 0, decimal = 2) {
      return valor.toLocaleString('pt-br', {
        minimumFractionDigits: decimal,
      });
    },

    valorSubTotalReal(valor = 0, maximumFractionDigits = undefined) {
      return valor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits,
      });
    },
    valorRealQuantidade(valor = 0, decimal = 2) {
      return valor.toLocaleString('pt-br', {
        minimumFractionDigits: decimal,
      });
    },
    formatDate(value, fmt = 'DD/MM/YYYY') {
      return value === null ? '' : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt);
    },
  },
};
